import { useTranslation } from "react-i18next";
import { isValidAsin, isValidKeywordCharset } from "../../../modules/advertising/utils/keywordValidation";
import { StringListInput, type StringListInputProps } from "./StringListInput";

const VALID_DOMAIN_REGEX = /^(?!:\/\/)([a-zA-Z0-9-_]{1,63}\.)+[a-zA-Z]{2,}$/;

type PresetProps = Omit<StringListInputProps, "normalizer" | "validator">;

export function AsinListInput(props: PresetProps) {
  const { t } = useTranslation(["validation"]);
  return (
    <StringListInput
      {...props}
      normalizer={(s) => s.trim().toUpperCase()}
      validator={(s) => (isValidAsin(s) ? null : t(($) => $.validation['"{value}" is not a valid ASIN'], { value: s }))}
    />
  );
}

export function KeywordListInput(props: PresetProps) {
  const { t } = useTranslation(["validation"]);
  return (
    <StringListInput
      {...props}
      validator={(s) =>
        isValidKeywordCharset(s) ? null : t(($) => $.validation['"{value}" is not a valid keyword'], { value: s })
      }
    />
  );
}

export function DomainListInput(props: PresetProps) {
  const { t } = useTranslation(["validation"]);
  return (
    <StringListInput
      {...props}
      validator={(s) =>
        VALID_DOMAIN_REGEX.test(s) ? null : t(($) => $.validation['"{value}" is not a valid domain'], { value: s })
      }
    />
  );
}
